/* Tab item H (Oct 12 2026): phone menu accordion */
(function(){
  function init(){
    document.querySelectorAll('.tab-mnav__btn').forEach(function(b){
      if (b.dataset.tabBound) return; b.dataset.tabBound='1';
      b.addEventListener('click', function(){
        var open = b.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        document.querySelectorAll('.tab-mnav__btn[aria-expanded="true"]').forEach(function(o){ if (o!==b){ o.setAttribute('aria-expanded','false'); var p=document.getElementById(o.getAttribute('aria-controls')); if(p) p.hidden=true; } });
        b.setAttribute('aria-expanded', open ? 'false' : 'true'); if (panel) panel.hidden = open;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Oct 13 2026: random colour swatch per menu thumbnail on every page load (data-pool written by snippets/tab-nav-links.liquid) */
(function(){
  function shuffleThumbs(){
    var thumbs = document.querySelectorAll('.tab-nav__thumb[data-pool]');
    for (var i = 0; i < thumbs.length; i++) {
      var t = thumbs[i]; if (t.dataset.tabRandomized) continue; t.dataset.tabRandomized = '1';
      var img = t.querySelector('img'); if (!img) continue;
      var pool = (t.getAttribute('data-pool') || '').split('|').filter(Boolean); if (pool.length < 2) continue;
      var src = img.getAttribute('src') || ''; var cut = src.indexOf('/cdn/shop/'); if (cut < 0) continue;
      var base = src.slice(0, cut + 10);
      var pick = pool[Math.floor(Math.random() * pool.length)];
      img.setAttribute('src', base + pick + (pick.indexOf('?') >= 0 ? '&' : '?') + 'width=120');
      img.removeAttribute('srcset');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shuffleThumbs); else shuffleThumbs();
  document.addEventListener('shopify:section:load', shuffleThumbs);
})();
